import Http from "../engine/Http";
import { Identifiable } from "../model/Items";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

export interface SpringMaterialModel {
  name: string;
  diameter: number;
  height: number;
  thickness: number;
  purpose: 'BONNELL'|'POCKET';
}
export interface SpringMaterial
extends Identifiable,
        SpringMaterialModel {
};

const useSpringMaterialApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchBonnellSpringMaterials = (): Promise<SpringMaterial[]> =>
    Http.get(`/api/bonnell-spring-materials`, [ authenticationHeader ]);

  const fetchPocketSpringMaterials = (): Promise<SpringMaterial[]> =>
    Http.get(`/api/pocket-spring-materials`,[ authenticationHeader ]);

  return {
    fetchBonnellSpringMaterials,
    fetchPocketSpringMaterials
  };
};

export default useSpringMaterialApi;